// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST,
    FIRMWARE_ASSIGN_GET_DEVICE_REQUEST,
    FIRMWARE_ASSIGN_FIRMWARE_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    firmwareAssignGetFirmwareResult,
    firmwareAssignGetDeviceResult,
    firmwareAssignFirmwareResult,
} from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getFirmware({ payload }) {
    try {

        let QUERY = `
            query getFirmware ($id: Int!) {
                result: getFirmware (id: $id) {
                    id
                    manufacturerId
                    hardwareVersion
                    firmwareId
                    version
                    isDefault
                    build
                    description
                    fileUrl
                    isActive
                    releaseTime
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(firmwareAssignGetFirmwareResult(data?.result))

    } catch (exc) {
        yield put(firmwareAssignGetFirmwareResult());
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/redux/saga",
            "getFirmware"
        )
    }
}

function* getDevice({ payload }) {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        simCard {
                            iccId
                            msisdn
                            simProviderAccount {
                                id
                                name
                                simProviderId
                                simProvider {
                                    id
                                    name
                                }
                            }
                        }
                        deviceModel {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                        unitConfig {
                            unitId
                            configVersion
                            scriptVersion
                            password
                            cameraInfo
                            cameraInfoUpdated
                            simState
                            firmwareId
                            hardwareVersion
                            cameraConfig
                        }
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(firmwareAssignGetDeviceResult(data?.result))
        } else {
            yield put(firmwareAssignGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(firmwareAssignGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/redux/saga",
            "getDevice",
        )
    }
}

function* assignFirmware({ payload }) {
    try {
        let QUERY = `
            mutation updateVidFleetAssignFirmware ($verificationCode: String, $firmwareUpdateGroups: [FirmwareUpdateInput]!) {
                result: updateVidFleetAssignFirmware (verificationCode: $verificationCode, firmwareUpdateGroups: $firmwareUpdateGroups)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(firmwareAssignFirmwareResult(data?.result));

    } catch (exc) {
        yield put(firmwareAssignFirmwareResult({error: exc}))
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/redux/saga",
            "assignFirmware",
        )
    }
}

function* watchMethods() {
    yield takeEvery(FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST, getFirmware);
    yield takeEvery(FIRMWARE_ASSIGN_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(FIRMWARE_ASSIGN_FIRMWARE_REQUEST, assignFirmware);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}